import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { AggregatedUpdates } from '../../../../@types/update';
import { UpdateTypeEnum } from '../../../../consts/enums';
import STRING_KEYS from '../../../../language/keys';

type Title = {
  key: string,
  count: number,
  accountName: string,
  positionName: string,
  talentName: string,
  userName?: string,
  userEmail?: string,
  wasMatchFlowTriggered?: boolean,
}

export default function TasksTitle(task: AggregatedUpdates): JSX.Element | string {
  const generateTitle = ({
    key, count, accountName, positionName, talentName, userName, userEmail, wasMatchFlowTriggered,
  }: Title): JSX.Element => {
    return (
      <Trans
        i18nKey={ key }
        count={ count }
      >
        <Typography
          variant="subtitle2"
          component="span"
        />
        <Typography
          component="span"
          variant="subtitle2"
          sx={ {
            color: 'primary.main',
          } }
        />
        {{ userName }}
        {{ accountName }}
        {{ positionName }}
        {{ talentName }}
        {{ userEmail }}
        {{ wasMatchFlowTriggered }}
      </Trans>
    );
  };
  switch (task.type) {
    case UpdateTypeEnum.matchFlowFailed: {
      return generateTitle({
        key: STRING_KEYS.HOME_PAGE.TASKS.MATCH_FLOW_FAILED,
        count: task.aggAmount,
        accountName: task.accountName,
        positionName: task.jobTitle,
        talentName: task.talentName,
        userName: task.userName,
      });
    }
    case UpdateTypeEnum.RequestedNewMatches: {
      return generateTitle({
        key: STRING_KEYS.HOME_PAGE.TASKS.REQUEST_MATCHES,
        count: task.aggAmount,
        accountName: task.accountName,
        positionName: task.jobTitle,
        talentName: task.talentName,
        userName: task.userName,
      });
    }
    case UpdateTypeEnum.OnboardingCompleted: {
      return generateTitle({
        key: STRING_KEYS.HOME_PAGE.TASKS.ONBOARDING_COMPLETED,
        count: task.aggAmount,
        accountName: task.accountName,
        userEmail: task.userEmail,
        wasMatchFlowTriggered: task.wasMatchFlowTriggered,
        positionName: task.jobTitle,
        talentName: task.talentName,
      });
    }
    case UpdateTypeEnum.matchStatusUpdated: {
      return generateTitle({
        key: STRING_KEYS.HOME_PAGE.TASKS.UPDATED_STATUS,
        count: task.aggAmount,
        accountName: task.accountName,
        positionName: task.jobTitle,
        talentName: task.talentName,
      });
    }
    case UpdateTypeEnum.contactRequest: {
      return generateTitle({
        key: task.aggAmount > 1 ?
          STRING_KEYS.HOME_PAGE.TASKS.CONTACT_INFO_AGGREGATED :
          STRING_KEYS.HOME_PAGE.TASKS.CONTACT_INFO,
        count: task.aggAmount,
        accountName: task.accountName,
        positionName: task.jobTitle,
        talentName: task.talentName,
      });
    }
    case UpdateTypeEnum.engagementRequest: {
      return generateTitle({
        key: task.aggAmount > 1 ?
          STRING_KEYS.HOME_PAGE.TASKS.ENGAGE_AGGREGATED :
          STRING_KEYS.HOME_PAGE.TASKS.ENGAGE,
        count: task.aggAmount,
        accountName: task.accountName,
        positionName: task.jobTitle,
        talentName: task.talentName,
      });
    }
    default: {
      return '';
    }
  }
}
